<template>
  <div class="menu-wrapper">
    <template v-if="!item.children || item.children.length ==0">
      <el-menu-item :index="item.to">
        <i :class="item.icon"/>
        <span slot="title">&nbsp;{{item.title}}</span>
      </el-menu-item>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.to)" :popper-append-to-body="true">
      <template slot="title">
        <i :class="item.icon" />
        <span slot="title" v-show="!collapse">&nbsp;{{item.title}}</span>
      </template>
      <menu-item
        v-for="child in item.children"
        :base-path="resolvePath(child.to)"
        :item="child"
        :key="child.to"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
export default {
  name: "MenuItem",
  props: {
    item: { type: Object, required: true },
    basePath: { type: String, default: "" },
    collapse: { type: Boolean, default: false }
  },
  methods: {
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    }
  }
};
</script>

<style>
</style>